import '@/assets/styles/index.less'
import 'amfe-flexible'
import 'normalize.css/normalize.css'
import 'swiper/dist/css/swiper.css'
import Vant, { Dialog } from 'vant'

import 'vant/lib/index.less'
// import Vconsole from 'vconsole'
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueCropper from 'vue-cropper'
import VueTouch from 'vue-touch'
import App from './App.vue'
import wxPlugin from './plugins/wx-plugin'
import router from './router'
import store from './store'
import * as filters from './utils/filter'
import { commonUtils } from './utils/common'
import VueBus from 'vue-bus'
Vue.use(VueBus)

// let vConsole = new Vconsole()
// export default vConsole

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'

Vue.prototype.$getImgUrl = function (img, defaultUrl) {
  if (!defaultUrl) {
    defaultUrl = require('./assets/images/image-not-found.png')
  }
  return img ? 'https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra' + img : defaultUrl
}

commonUtils.preventClick()

Vue.use(Vant)
Vue.use(Dialog)
Vue.use(wxPlugin)
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VueAwesomeSwiper)
Vue.use(VueCropper)

VueTouch.config.swipe = {
  threshold: 100
}

// global.entryUrl = location.href.split('#')[0]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
